import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const FilialCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    id: 0,
    nome: "",
    telefone: "",
    whatsapp: "",
    email: "",
    endereco: "",
    nome_in: "",
    nome_es: "",
    ativo: 1
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  // const carregarDados = async () => {
  //   try {
  //     showLoading(".ibox-content");

  //     const requisicao = await api.get(`/filial/consultar`);

  //     const { data } = requisicao;

  //     if (!data.status) {
  //       danger(data.mensagem);
  //       return;
  //     }

  //     if (!data.data) {
  //       return;
  //     }

  //     setState(data.data);
  //   } catch (error) {
  //     console.log(error);
  //     danger("Erro ao carregar os dados da filial");
  //   } finally {
  //     showLoading(".ibox-content");
  //   }
  // };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-filial").valid()) {
      return;
    }

    try {
      const formData = new FormData();

      formData.append("id", state.id);
      formData.append("nome", state.nome);
      formData.append("nome_in", state.nome_in);
      formData.append("nome_es", state.nome_es);
      formData.append("telefone", state.telefone);
      formData.append("whatsapp", state.whatsapp);
      formData.append("email", state.email);
      formData.append("endereco", state.endereco);
      formData.append("ativo", state.ativo);

      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/filial", formData);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
     // carregarDados();
      history.push("/filial");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar a filial.");
    }
  };

  const buscarDados = async (url) => {
    const requisicao = await api.get(`${url}`);

    const { data } = requisicao;

    if (!data.status) {
      danger(data.mensagem);
      return;
    }

    if (!data.data) {
      return;
    }

    return data.data;
  };

  const carregarDados = async () => {
    if (!location.state) {
      return;
    }

    return await buscarDados(`/filial/${location.state.id}`);
  };

  useEffect(() => {
    const carregarTodosDados = async () => {
      try {
        showLoading(".ibox-content");

        const [filial] = await Promise.all([carregarDados()]);

        if (filial) {
          setState(filial);
        }

        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados da filial");
      }
    };

    let validacao = window.$("#form-filial").validate(validate);

    carregarTodosDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Filial"
        header="Cadastro da Filial"
        action={{ titulo: "Voltar", link: "/filial" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados da filial</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <form id="form-filial">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                        <label>Nome/Descrição</label>
                        <input
                            type="text"
                            placeholder="Nome da filial"
                            className="form-control"
                            name="nome"
                            value={state.nome}
                            onChange={(e) => preencherValoresEdits(e)}
                        />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>Nome/Descrição IN</label>
                          <input
                            type="text"
                            placeholder="Nome da filial em inglês"
                            className="form-control"
                            name="nome_in"
                            value={state.nome_in}
                            onChange={(e) => preencherValoresEdits(e)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>Nome/Descrição ES</label>
                          <input
                            type="text"
                            placeholder="Nome da filial em espanhol"
                            className="form-control"
                            name="nome_es"
                            value={state.nome_es}
                            onChange={(e) => preencherValoresEdits(e)}
                          />
                        </div>
                      </div>
                    </div>

                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Endereço da filial</label>
                            <input
                              type="text"
                              placeholder="Endereço da filial"
                              className="form-control"
                              name="endereco"
                              value={state.endereco}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Telefone da filial</label>
                            <input
                              type="text"
                              placeholder="Telefone da filial"
                              className="form-control"
                              name="telefone"
                              value={state.telefone}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Whatsapp da filial</label>
                            <input
                              type="text"
                              placeholder="Whatsapp da filial"
                              className="form-control"
                              name="whatsapp"
                              value={state.whatsapp}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>E-mail da filial</label>
                            <input
                              type="text"
                              placeholder="E-mail da filial"
                              className="form-control"
                              name="email"
                              value={state.email}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        
                      </div>
                      
                      <div className="row">
                        <div className="col-lg-2">
                            <div className="form-group">
                              <label>Status da filial</label>
                              <select
                                className="form-control"
                                id="ativo"
                                name="ativo"
                                value={state.ativo}
                                onChange={(e) => preencherValoresEdits(e)}
                              >
                                <option key="1" value={1}>
                                  Ativo
                                </option>

                                <option key="2" value={0}>
                                  Inativo
                                </option>
                              </select>
                            </div>
                          
                        </div>
                      </div>

                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default FilialCadastrar;
